import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import SectionLoading from "../common/SectionLoading";
import Spinner from "../common/spinner";
import ConfirmationModal from "../common/ConfirmationModal";
import StatusBanner from '../common/StatusBanner';
import SectionLoadingError from '../common/SectionLoadingError';
import ZipnosisError from "./ZipnosisError";

class EVisitGetStarted extends React.Component {
    constructor(props) {
        super(props);
        this.state = { started: false, redirectedToZipnosis: false };
        this.redirectToZipnosis = this.redirectToZipnosis.bind(this);
        this.formChanged = false;
    }

    componentDidMount() {
        this.formChanged = false;
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.userIsSwitching && nextProps.userIsSwitching) {
            if (this.state.started) {
                this.setState({ started: false });
            }
        }
    }

    startEvisit = (action, subUrl) => {
        //debugger;
        const { userData, token, eVisitZipGroupId, eVisitExternalId, userName, eVisit, getZipnosisEvisitUrl, userTags, index } = this.props;
        this.title = action === 'COVID19' ? 'screening' : 'eVisit';
        //const eVisitZipGroupId = eVisit.bswZipGroup?.id;
        //const eVisitExternalId = eVisit?.externalId;

        logUI('MBHWeb.Evisits.Start.Zipnosis.' + action, new Date(), Tools.getURLPath(), userData, 'eVisits', 'Zipnosis' + userTags());

        if (!this.started) {
            getZipnosisEvisitUrl(token, userName, eVisitZipGroupId, index && eVisitExternalId ? eVisitExternalId : null, 'EXTERNAL', subUrl);
        }

        if (!this.started) {
            this.setState({ started: true });
            this.formChanged = true;
        }
    }

    completeZipnosisRedirect = () => {
        //debugger;
        const { userData, userTags } = this.props;
        logUI('MBHWeb.Evisits.Start.Zipnosis.Redirect', new Date(), Tools.getURLPath(), userData, 'eVisits', 'Zipnosis' + userTags());
        this.setState({ redirectedToZipnosis: true });
    }

    redirectToZipnosis(url) {
        //debugger;
        var newWin = window.open(url, '_blank');
        if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
            return (
                <div className="row evisit-popup">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">eVisit</h1>
                        <div className="evisit-popup__msg">
                            <span className="icon-info-filled" />
                            <div className="evisit-popup__msg--text">
                                <p>We attempted to launch eVisits in a new window, but a popup blocker is preventing it.</p>
                                <p>Please allow popups for this site and try again.</p>
                            </div>
                        </div>
                        <a className="btn btn-primary" href={url} target="_blank" onClick={this.completeZipnosisRedirect}>TRY AGAIN</a>
                    </div>
                </div>
            );
        }
        else {
            this.completeZipnosisRedirect();
            return <Redirect to='/' />;
        }
    }

    format = (text) => {
        if (text.indexOf('-') > -1) {
            const words = text.split(' ');
            for (var i = 0; i < words.length; i++) {
                if (words[i].indexOf('-') > -1) {
                    words[i] = '<span class="no-wrap-text">' + words[i] + '</span>';
                }
            }
            return words.join(' ');
        }
        return text;
    }

    render() {
        const { eVisit, eVisitZipGroupId, isPrimaryUser, heading, zipnosis, userIsSwitching, serverData, token, hasError, errorMessage, errorMessageName, activeUserFirstName, outOfStateOptionsForEVisit, hasSWHP } = this.props;
        // remove $ from cost label to preserve special styling we have
        //let cost = eVisitCost.replace('$', '');
        let cost = 40;
        let costLabel = 'Cost';

        if (isPrimaryUser && eVisit.bswZipGroup && typeof eVisit.bswZipGroup.price !== 'undefined' && eVisit.bswZipGroup.price !== null) {
            cost = eVisit.bswZipGroup.price;
        }

        if (userIsSwitching) return null;

        if (this.state.started && zipnosis && !zipnosis.loading && !this.state.redirectedToZipnosis && hasError) {
            return <ZipnosisError title={this.title} errorMessage={errorMessage} errorMessageName={errorMessageName} userTags={this.props.userTags} />;
        }

        const covid19ButtonText = serverData && serverData.covid19ButtonText ?
            activeUserFirstName ? "START " + activeUserFirstName + "'s " + serverData.covid19ButtonText : "START " + serverData.covid19ButtonText : activeUserFirstName ? "START " + activeUserFirstName + "'s SCREENING" : "START SCREENING";
        const evisitsProtocolList = serverData.EvisitsProtocolList
        const evisitsListArray = evisitsProtocolList.split('|')

        return (
            <div className="row evisit-start-container">
                <div className="col-12">
                    {this.state.started
                        ? !zipnosis || zipnosis.loading
                            ? <Spinner />
                            : this.state.redirectedToZipnosis
                                ? <Redirect to='/' />
                                : zipnosis.url && !errorMessage
                                    ? this.redirectToZipnosis(zipnosis.url)
                                    : null
                        : <>
                            {serverData && serverData.EvisitsEnabled === false && serverData.EvisitBackedUpHeading && serverData.EvisitBackedUpMessage
                                ? <StatusBanner
                                    bannerMsg={serverData.EvisitBackedUpHeading}
                                    subBannerMsg={serverData.EvisitBackedUpMessage}
                                    failedStatus
                                />
                                : <React.Fragment>
                                    {serverData && serverData.ZipnosisBackedUp && serverData.ZipnosisBackedUpMessage &&
                                        <div className="row evisit-backed-up-msg-container">
                                            <div className="col-12 maxWidth-content">
                                                <SectionLoadingError
                                                    messageIcon="icon-important"
                                                    message={serverData.ZipnosisBackedUpMessage}
                                                    sectionErrorClass="evisit-backed-up-msg"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {serverData && serverData.covid19ScreeningEnabled &&
                                        <div className={"row covid-19" + (serverData.covid19Cost && serverData.covid19Cost !== "" ? "" : " no-note")}>
                                            <div className="col-12 maxWidth-content covid-19__body">
                                                <div className="covid-19__text">
                                                    <div className="covid-19__title">{' '}COVID-19</div> <span className="covid-19__subtitle">{serverData.covid19Text}{' '}</span>
                                                </div>
                                                <div className="covid-19__cost-label">
                                                    <div className="d-flex align-items-center covid-19__cost">
                                                        <span>Cost:</span> <div className="d-flex align-items-center"><span>&nbsp;$</span><span className="evisit-cost-est__price">0</span></div>
                                                    </div>
                                                </div>
                                                <div className="covid-19__link">
                                                    <div className="btn btn-primary" onClick={() => this.startEvisit('COVID19', serverData.covid19SubUrl)}>{covid19ButtonText}</div>
                                                </div>
                                            </div>
                                            {serverData.covid19Cost &&
                                                <div className="col-12 covid-19__footer">
                                                    <div className="row">
                                                        <div className="col-12 maxWidth-content">
                                                            <div className="covid-19__note">{serverData.covid19Cost}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    <div className="row">
                                        <div className="col-12 maxWidth-content">
                                            <h1 className="page-heading">{heading}</h1>
                                            <div className="page-subheading">Skip the doctor's office with an eVisit.</div>
                                        </div>
                                    </div>

                                    <div className="row evisit-steps">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className="col-12 col-md-3 evisit-steps__group">
                                                    <div className="svg-interview" />
                                                    <h4>Online Interview</h4>
                                                </div>
                                                <div className="col-12 col-md-3 evisit-steps__group">
                                                    <div className="svg-diagnosis" />
                                                    <h4>Diagnosis by a Clinician</h4>
                                                </div>
                                                <div className="col-12 col-md-3 evisit-steps__group">
                                                    <div className="svg-prescription" />
                                                    <h4>Response & Prescription <span>(if needed)</span> in 1hr</h4>
                                                </div>
                                                <div className="col-12 col-md-3 evisit-steps__group">
                                                    <div className="svg-doctor-note" />
                                                    <h4>Doctor's Note <span>(if needed)</span></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row evisit-cost-est">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className={`col-12 col-md-4 col-lg-6 col-xl-3 d-flex align-items-center`}>
                                                    <span>{costLabel}:</span> <div className="d-flex align-items-center"><span>&nbsp;$</span><span className="evisit-cost-est__price">{cost}</span></div>
                                                </div>
                                                <div className={`col-12 col-md-8 col-lg-6 col-xl-9 d-flex align-items-center`}>
                                                    <button className="btn btn-primary" onClick={() => this.startEvisit('StartEVisit')}>Start eVisit</button>

                                                    <button className="btn btn-primary" onClick={() => this.startEvisit('ReviewEVisit')}>Review Results</button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {outOfStateOptionsForEVisit && <div className="row evisit-travel">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className="col-12 col-md-6 col-xl-3 d-flex align-items-center evisit-travel__heading"><div className="svg-plane" />Traveling outside Texas?</div>
                                                <div className="col-12 col-md-6 col-xl-9 d-flex align-items-center"><Link className="icontextlink mobile-wrapped-link" to={{ pathname: "/evisittravel" }} >SEE MORE OPTIONS <span className="icon-arrow-sm-rt" /></Link></div>
                                            </div>
                                        </div>
                                    </div>}

                                    <div className="row evisit-symptoms">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                {hasSWHP && <div className="col-10 col-md-12 swhp-disclaimer">
                                                    Baylor Scott & White Health Plan HDHP (high deductible health plan) members will be sent a bill after receiving care.
                                                </div>}
                                                <div className="col-12"><h4>Symptoms we treat:</h4></div>
                                                <div className="col-12 col-xl-8">
                                                    <div className="row">
                                                        <div className="col-12 col-md-6 col-xl-6">
                                                            <ul className="angle-bullets">
                                                                {evisitsListArray.slice(0, Math.round(evisitsListArray.length / 2)).map((item, index) => (
                                                                    <li key={index} className="content" dangerouslySetInnerHTML={{ __html: this.format(item)}}></li>
                                                                ))}
                                                                {hasSWHP &&
                                                                    <li>
                                                                        Depression/Anxiety
                                                                        <div className="bh-subitem">(Response in 2hrs, prescription not available)</div>
                                                                    </li>
                                                                }
                                                            </ul>
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-6">
                                                            <ul className="angle-bullets">
                                                                {evisitsListArray.slice(Math.round(evisitsListArray.length / 2)).map((item, index) => (
                                                                    <li key={index} className="content" dangerouslySetInnerHTML={{ __html: this.format(item)}}></li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                        </>
                    }
                </div>

                {this.state.started &&
                    <ConfirmationModal when={this.formChanged} message="Would you like to leave this page and lose changes?" />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userName: state.domain.un,
        token: state.domain.t,
        zipnosis: state.header.zipnosis,
        userIsSwitching: state.memberships.switchingProxyUser,
        index: state.memberships.currentUser?.index,
        serverData: state.session.serverData,
        hasError: state.header && state.header.zipnosis ? state.header.zipnosis.hasError : false,
        errorMessage: state.header && state.header.zipnosis ? state.header.zipnosis.errorMessage : "",
        errorMessageName: state.header && state.header.zipnosis ? state.header.zipnosis.errorMessageName : "",
        eVisit: state.memberships.currentUserEVisit,
        hasSWHP: state.memberships.hasAnySWHP,
        eVisitZipGroupId: state.memberships.eVisitZipGroupId,
        eVisitExternalId: state.memberships.eVisitExternalId,
        outOfStateOptionsForEVisit: state.memberships.outOfStateOptionsForEVisit
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getZipnosisEvisitUrl: (token, userName, zipGroupId, patientId, patientIdType, subUrl) => {
            dispatch({ type: types.ZIPNOSIS_EVISIT_URL, token, userName, zipGroupId, patientId, patientIdType, subUrl });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EVisitGetStarted);